export default "__VITE_ASSET__DmZR6UgF__"